import { formatMessageToTranslationKey } from '@shared/utils/translation'
import { useTranslations } from 'next-intl'

type Error =
  | {
      message?: string
    }
  | undefined

export default function useLocaleErrorMessage() {
  const tErrors = useTranslations('generic.errors')
  const tValidation = useTranslations('validation')

  const getErrorMessage = (error: Error) => {
    if (!error || !error.message) return undefined

    // Check if message is a JSON string with key and values for interpolation
    try {
      const parsed = JSON.parse(error.message)
      if (parsed.key && parsed.key.startsWith('validation.')) {
        const validationKey = parsed.key.replace('validation.', '')
        return tValidation.has(validationKey)
          ? tValidation(validationKey, parsed.values)
          : error.message
      }
    } catch {
      // Not JSON, continue with regular processing
    }

    // Check if message is already a translation key (e.g., 'validation.passwordMinLength')
    if (error.message.startsWith('validation.')) {
      const validationKey = error.message.replace('validation.', '')
      return tValidation.has(validationKey)
        ? tValidation(validationKey)
        : error.message
    }

    // Legacy support: try to format the message as a key for generic.errors
    const formattedKey = formatMessageToTranslationKey(error.message)
    const message = tErrors.has(formattedKey)
      ? tErrors(formattedKey)
      : error.message

    return message
  }

  return getErrorMessage
}
